<template>
  <AddSlider update />
</template>
<script>
import AddSlider from '../../../components/skillup/firstSlider/AddSlider.vue'
import appConfig from '../../../app.config.json'

export default {
  page: {
    title: 'ویرایش کردن اسلایدر',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillup-edit-slider',
  components: { AddSlider },
}
</script>
